import React, { Component } from 'react';
import { get,post } from '../utils/request';
// component
import Banner from '../components/banner';
import TopDom from '../components/top';
import queryString from 'query-string';
import { wxShare } from '../utils/util';

// css
import '../assets/css/success.scss';
import { UserInfoClass } from '../components/groupPerson';

class Success extends Component {
  constructor(props) {
    super(props);
    this.state = {
      endReCourse: false,
      showDefaultSuccessView: true, 
      successText: '',
      successImg: '',
    }
  }

  getPageInfo = () => {
    post('/fancube/apply/apply_info/', {
      "code": this.pageUrlValues.acid
    })
    .then(res => {
      if (res.code === 200) {
        this.setState({
          showDefaultSuccessView: res.data.define_sign_up.is_default_success == 1 ? true : false, // 跳转成功页面数据
          successText: res.data.define_sign_up.success.content,
          successImg: res.data.define_sign_up.success.qr_code,
        })
      }
    })
  }
  
  // get('/api/website/actives/?p=1&n=3')
  getReCourse = () => {
    post('/fancube/apply/success-recommend/', {
      "code": this.pageUrlValues.acid
    })
    .then(res => {
      if (res.code === 200) {
        this.setState({
          reCourse: res.data.recommends,
          endReCourse: true
        }) 
      }
    })
  }
  componentDidMount() {
    let useInfo = localStorage.getItem('formPageSto') && JSON.parse(localStorage.getItem('formPageSto'));
    if (useInfo && useInfo.banner) {
      this.setState({
        bannerUrl: useInfo.banner,
      })
    }
    if(useInfo && useInfo.title) {
      document.title = useInfo.title;
      let wxTitle = `我已报名成功，邀请你一起报名${useInfo.title}`;
      let wxDes = `我正在报名小饭桌的活动，赶紧一起报名吧~`;
      let wxUrl = useInfo.shareUrl;
      wxShare(wxTitle, wxDes, wxUrl);
    }

    const urlValues = queryString.parse(this.props.location.search);
    this.pageUrlValues = urlValues;

    this.getPageInfo();
    this.getReCourse();
  }
  render () {
    return (
      <div className="success-wrapper page-wrapper">
        <TopDom />
        <Banner url={this.state.bannerUrl}/>
        <div className="submit-success need-clear">
          <p className="success">提交成功！</p>
          <div className="subscribe">
            { this.state.showDefaultSuccessView ?
              <div> 
                <div className="subscribe-title">关注小饭桌创业课堂服务号</div>
                <div className="subscribe-desc">获取报名进展通知</div>
                <div className="subscribe-qrcode">
                  <img src="https://static-image.xfz.cn/xfz-school-wechat-share.png" alt="服务号二维码" />
                </div>
              </div>
            : 
              <div> 
                <div className="subscribe-title" dangerouslySetInnerHTML={{__html: this.state.successText}}></div> <br/>
                <div className="subscribe-qrcode2">
                  <img src={this.state.successImg} alt="服务号二维码" />
                </div>
              </div>
            }

          </div>
          {
            this.state.endReCourse &&
            <div className="active-wrap">
              <div className="active-title">推荐阅读</div>
              <ul className="active-list default-ul-style">
                {
                  this.state.reCourse.map(val => {
                    return (
                      <li key={val.url}>
                        <a href={val.url} target="_blank"  rel="noopener noreferrer">
                          <img src={`${val.img_url}-website.events.list`} alt="课堂图" />
                          <div className="re-title">{val.title}</div>
                        </a>
                      </li>
                    )
                  })
                }
              </ul>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default Success;